import { render, staticRenderFns } from "./ContestGame.vue?vue&type=template&id=647c4581&scoped=true&"
import script from "./ContestGame.vue?vue&type=script&lang=js&"
export * from "./ContestGame.vue?vue&type=script&lang=js&"
import style0 from "./ContestGame.vue?vue&type=style&index=0&id=647c4581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c4581",
  null
  
)

export default component.exports